import { render, staticRenderFns } from "./anular.vue?vue&type=template&id=15d6e058&"
import script from "./anular.vue?vue&type=script&lang=js&"
export * from "./anular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports